import Forms from "./Forms";
import LazyLoad from "../components/LazyLoad";

const FilterComponent = class FilterComponent {

  constructor() {
    this.form = new Forms();
  }

  init() {
    this.filterCategory();
    //this.filterSubcategory();
  }


  filterCategory() {
    let lazy = new LazyLoad();
    let self = this;

    $('#category, #subcategory').on('change', function () {
      let selectedCategoryValue = $('#category option:selected').val();
      let selectedSubcategoryValue = $('#subcategory option:selected').val();

      if (selectedCategoryValue !== 'all') {
        if(selectedSubcategoryValue !== 'all') {
          window.location.href = homeURL + '/proizvodi/' + selectedSubcategoryValue + '/?main_category=' + selectedCategoryValue;
        } else {
          window.location.href = homeURL + '/proizvodi/' + '?main_category=' + selectedCategoryValue;
        }
      } else {
        if(selectedSubcategoryValue !== 'all') {
          window.location.href = homeURL + '/proizvodi/' + selectedSubcategoryValue;
        } else {
          window.location.href = homeURL + '/proizvodi/';
        }
      }

      // $.ajax({
      //   url: apiUrl + 'filter-category',
      //   method: 'GET',
      //   data: {
      //     'main_category': this.value
      //   }
      // }).done(function (data) {
      //   //console.log(data);
      //   //console.log($('#subcategory option:selected').val());
      //   // $('.js-paginated-items').html(data.products_partial);
      //   // $('.js-pagination').html(data.pagination.pagination);
      //   // lazy.init();
      //   // if (data.subcategories.length == 0) {
      //   //   let selectedValue = $('#category option:selected').val();
      //   //   if (selectedValue == 'all') {
      //   //     window.location.href = homeURL + '/proizvodi';
      //   //   } else {
      //   //     window.location.href = homeURL + '/proizvodi/' + '?main_category=' + selectedValue;
      //   //   }
      //   //
      //   // } else {
      //   //   $('.filter--2').html(data.subcategories_partial);
      //   //   self.form.customSelect();
      //   //
      //   //   let selectedValue = $('#category option:selected').val();
      //   //   console.log('SEelected: '+selectedValue);
      //   //   if (selectedValue !== 'all') {
      //   //     window.location.href = homeURL + '/proizvodi/' + '?main_category=' + selectedValue;
      //   //
      //   //   } else {
      //   //     console.log('Sveee');
      //   //     window.location.href = 'http://www.google.rs';
      //   //
      //   //   }
      //
      //
      //
      //     // let url = homeURL + '/proizvodi/' + $('#category option:selected').val();
      //     // let category = this.value;
      //     // window.location.href = url;
      //   //}
      // }).fail(function (error) {
      //   console.log(error);
      // });

    });
  }


  // filterSubcategory() {
  //   $(document).on('change', '#subcategory', function () {
  //     let url;
  //     if(mainCategory !== '') {
  //       url = homeURL + '/proizvodi/' + $('#subcategory option:selected').val() + '?main_category=' + mainCategory;
  //     } else {
  //       url = homeURL + '/proizvodi/' + $('#subcategory option:selected').val();
  //     }
  //     let category = this.value;
  //     window.location.href = url;
  //   });
  //
  //   //Disable if parent-cat not selected
  //   let selectedValue = $('#category').val();
  //
  //   if (selectedValue === '') {
  //     //$('#subcategory').parent().addClass('disabled');
  //   } else {
  //     //$('#subcategory').parent().removeClass('disabled');
  //   }
  //}


};

export {FilterComponent}


// WEBPACK FOOTER //
// ./static/js/components/FilterComponent.js